module.exports = __webpack_public_path__ + "static/media/combo_ride_3.f58c9203.png";